import { Observable } from 'rxjs';
import { ClinicDepartment, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class ClinicDepartmentService extends ApiService {
  endPoint = '/api/clinicDepartments';
  create(model: ClinicDepartment) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: ClinicDepartment) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<ClinicDepartment> {
    return this.http.get<ClinicDepartment>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<ClinicDepartment>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
}
